import { render } from "./SettingsHomeImagesForm.vue?vue&type=template&id=1ca2de73&scoped=true"
import script from "./SettingsHomeImagesForm.vue?vue&type=script&lang=js"
export * from "./SettingsHomeImagesForm.vue?vue&type=script&lang=js"

import "./SettingsHomeImagesForm.vue?vue&type=style&index=0&id=1ca2de73&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Haniel\\Desktop\\PROJECTS\\TANOU-ACADEMY\\e-commerce-webadmin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_2cebe3dcb9a4454fa15f9df2c44405de\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca2de73"]])

export default __exports__